import { render, staticRenderFns } from "./ExamPointRow.vue?vue&type=template&id=54122ff4&scoped=true&"
import script from "./ExamPointRow.vue?vue&type=script&lang=js&"
export * from "./ExamPointRow.vue?vue&type=script&lang=js&"
import style0 from "./ExamPointRow.vue?vue&type=style&index=0&id=54122ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54122ff4",
  null
  
)

export default component.exports